export const AD_CLIENT_ID = 'ca-pub-4477070546327805';

const DEFAULT_SLOT = '8084827009';

export type AdPlacement =
  | 'header'
  | 'article'
  | 'sidebar'
  | 'footer'
  | 'infeed'
  | 'multiplex';

const ENV_SLOT_MAP: Record<AdPlacement, string | undefined> = {
  header: process.env.REACT_APP_AD_SLOT_HEADER,
  article: process.env.REACT_APP_AD_SLOT_ARTICLE,
  sidebar: process.env.REACT_APP_AD_SLOT_SIDEBAR,
  footer: process.env.REACT_APP_AD_SLOT_FOOTER,
  infeed: process.env.REACT_APP_AD_SLOT_INFEED,
  multiplex: process.env.REACT_APP_AD_SLOT_MULTIPLEX
};

export const getAdSlot = (placement: AdPlacement): string => {
  return ENV_SLOT_MAP[placement] || DEFAULT_SLOT;
};

